/**
 * Created by Ning Jiang on 2021-06-21.
 */

import {gsap} from "gsap";
import {WaysWonTextContainer} from "./WaysWonTextContainer";
import {DeadwoodRipLayers, Layers} from "../../../view/DeadwoodRipLayers";

export class WaysWonCountUp extends PIXI.Container {

    private readonly _initialPositionY:number = 480;
    private readonly _bigWinPositionY:number = 600;

    private _waysWonContainer:WaysWonTextContainer;

    public set externalAlpha(value:number) {
        this._waysWonContainer.alpha = value;
    }

    public get externalAlpha():number {
        return this._waysWonContainer.alpha;
    }

    constructor() {
        super();

        this._waysWonContainer = new WaysWonTextContainer();
        this._waysWonContainer.visible = false;
        this.addChild(this._waysWonContainer);
        DeadwoodRipLayers.getLayer(Layers.WIN_COUNT_UP)?.addChild(this);
        // this.showWinWaysWon(5, false);
    }

    public showWinWaysWon(winWaysWon:number, isBigWin:boolean):TimelineLite {
        const tl = gsap.timeline();
        tl.add([
            () => {
                this._waysWonContainer.alpha = 0;
                this._waysWonContainer.visible = true;
                this.position.set(360, isBigWin ? this._bigWinPositionY : this._initialPositionY);
                this._waysWonContainer.show(winWaysWon);
            },
            gsap.to(this._waysWonContainer, {duration : 0.5, alpha : 1}),
        ]);

        return tl;
    }

    public stay():void {
        const tl = gsap.timeline();
        tl.add(gsap.to(this, {y : this._initialPositionY}));
    }

    public remove():TimelineLite {
        const tl = gsap.timeline();
        tl.add(gsap.to(this._waysWonContainer, {duration : 0.5, alpha : 0}), `+=0.2`);
        tl.add(() => {this._waysWonContainer.visible = false});
        return tl;
    }

    public showAfterRemoved():void {
        this._waysWonContainer.visible = true;
        this._waysWonContainer.alpha = 1;
    }

    public setColor(color:number):void {
        this._waysWonContainer.setColor(color);
    }
}